import request from '@/utils/request'


export function GetPageList(data) {
    return request({
        url: 'service/Qg.Services.UserService/GetPageList',
        method: 'post',
        data
    })
}


export function UpdateUser(data) {
    return request({
        url: 'service/Qg.Services.UserService/SaveUser',
        method: 'post',
         data
    })
}

export function SaveUser(data) {
    return request({
        url: 'service/Qg.Services.UserService/SaveUser',
        method: 'post',
         data
    })
}

export function DeleteUser(data) {
    return request({
        url: 'service/Qg.Services.UserService/DeleteUser',
        method: 'post',
         data
    })
}

export function getCurrentUser(data) {
    return request({
        url: 'service/Qg.Services.UserService/GetCurrentUser',
        method: 'post',
        data
    })
}

export function changePassword(data){
     return request({
        url: 'service/Qg.Services.UserService/ChangePassword',
        method: 'post',
         data
    })
}

export function changeUserPassword(data){
     return request({
        url: 'service/Qg.Services.UserService/ChangeUserPassword',
        method: 'post',
         data
    })
}

export function updateAvatar(data){
     return request({
        url: 'service/Qg.Services.UserService/UpdateAvatar',
        method: 'post',
         data
    })
}

export function updateUserInfo(data){
     return request({
        url: 'service/Qg.Services.UserService/UpdateUserInfo',
        method: 'post',
         data
    })
}

export function getUserRoles(data) {
    return request({
        url: 'service/Qg.Services.UserService/GetUserRoles',
        method: 'post',
         data
    })
}

export function setUserRole(data) {
    return request({
        url: 'service/Qg.Services.UserService/SetUserRole',
        method: 'post',
         data
    })
}

